import React, { createContext, useReducer, useState } from "react";
import { decodeAuthToken, normalizeAuthRole } from "../utils/authToken";
import { resetAddressGate } from "../utils/addressGate";

const buildStateFromToken = (token, extra = {}) => {
 const decoded = decodeAuthToken(token);
 if (!decoded) {
  return { isLoggedIn: false };
 }

 return {
  isLoggedIn: true,
  ...decoded,
  role: Array.isArray(decoded.role)
   ? decoded.role.find(Boolean) || decoded.role[0]
   : decoded.role,
  ...extra,
 };
};

const readAuthState = () => {
 const token = localStorage.getItem("authToken");
 if (!token) {
  return { isLoggedIn: false };
 }

 const state = buildStateFromToken(token);
 if (!state.isLoggedIn) {
  localStorage.removeItem("authToken");
  localStorage.removeItem("refreshToken");
 }
 return state;
};

const initialState = readAuthState();

export const UserContext = createContext(initialState);

export const InfoContext = createContext({
 info: null,
 setInfo: null,
});

export function UserStore({ children }) {
 const [info, setInfo] = useState(null);

 const [state, dispatch] = useReducer((state, action) => {
  switch (action.type) {
   case "LOGIN": {
    localStorage.setItem("authToken", action.payload.accessToken.token);
    localStorage.setItem(
     "refreshToken",
     `"${action.payload.refreshToken.token}"`
    );

    const { accessToken, refreshToken, ...rest } = action.payload;
    const next = buildStateFromToken(action.payload.accessToken.token, rest);
    if (!next.isLoggedIn) {
     localStorage.removeItem("authToken");
     localStorage.removeItem("refreshToken");
     return { isLoggedIn: false, name: "" };
    }
    return next;
   }

   case "HYDRATE_FROM_TOKEN": {
    const token = action.payload || localStorage.getItem("authToken");
    const next = buildStateFromToken(token);
    if (!next.isLoggedIn) {
     return { isLoggedIn: false, name: "" };
    }
    return next;
   }

   case "LOGOUT":
    resetAddressGate();
    localStorage.removeItem("authToken");
    localStorage.removeItem("refreshToken");
    return { isLoggedIn: false, name: "" };
   default:
    return state;
  }
 }, initialState);

 return (
  <UserContext.Provider value={[state, dispatch]}>
   <InfoContext.Provider
    value={{
     info: info,
     setInfo: setInfo,
    }}
   >
    {children}
   </InfoContext.Provider>
  </UserContext.Provider>
 );
}

export { normalizeAuthRole };
